<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Laporan Tutup Kaunter Harian">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <z-lookup
                            label="Kaunter"
                            :url="service_kutipan + 'lookup/kaunter'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.kaunter_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Pengguna"
                            :url="service_kutipan + 'lookup/user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.user_id"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <loading v-model:active="isLoading"
                 :can-cancel="false"
                 :opacity="0.7"
                 :is-full-page="false"/>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <w-tabs :items="tabs" :no-slider="false" active-class="primary">

                <template #item-content.1>
                    <z-table
                        ref="tbluser"
                        title=""
                        :headers="table.headers"
                        :items="table.items"
                        :meta="table.meta"
                        class=""
                    >
                    </z-table>
                    <!-- <table class="table-dashboard" width="100%">
                        <tbody>
                            <tr>
                                <td width="28%"><b>BILANGAN RESIT BATAL</b></td>
                                <td align="right"><b>{{resit_batal.bil}}</b></td>
                            </tr>
                            <tr>
                                <td><b>AMAUN RESIT BATAL (RM)</b></td>
                                <td align="right"><b>{{$zutil.currency(resit_batal.amaun)}}</b></td>
                            </tr>
                        </tbody>
                    </table> -->
                </template>
                <template #item-content.2>
                    <carabayar :cari="cari">
                    </carabayar>  
                </template>
                <template #item-content.3>
                    <kodakaun :cari="cari">
                    </kodakaun>
                </template>

            </w-tabs>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";
import Carabayar from './Kaunter/CaraBayar.vue'
import Kodakaun from './Kaunter/KodAkaun.vue'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    extends: ZResource,
    components: {
        // ZenOne
        Carabayar,
        Kodakaun,
        Loading,
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            resit_id: null,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/laporan_tutup_kaunter" },
                { label: "Laporan", route: "/kutipan/laporan/laporan_tutup_kaunter" },
                {
                    label: "Laporan Tutup Kaunter Harian",
                    route: "/kutipan/laporan/laporan_tutup_kaunter",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", user_id:"" },
            tabs: [
                { title: 'Senarai Resit', content: '' },
                { title: 'Ringkasan Mengikut Cara Bayar', content: '' },
                { title: 'Ringkasan Mengikut Kod Akaun', content: '' },
            ],
            resit_batal: {bil: '', amaun: ''},
            isLoading: false,
        };
    },
    methods: {
        search() {
            this.getQueryData();
            // this.$inertia.visit(
            //     window.route("kutipan.laporan.laporan_tutup_kaunter") +
            //         "?tarikh_dari=" +
            //         this.cari.tarikh_dari +
            //         "&tarikh_hingga=" +
            //         this.cari.tarikh_hingga +
            //         "&kaunter_id=" +
            //         this.cari.kaunter_id +
            //         "&user_id=" +
            //         this.cari.user_id,
            //     { preserveScroll: true }
            // );
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", kaunter_id: "", user_id: "" };
            this.search();
        },

        cetak() {
                window.open(this.service_laporan+'kutipan/laporan/kaunter/cetak_tutup_kaunter?tarikh_dari=' +
                    this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&kaunter_id=" + this.cari.kaunter_id +
                    "&user_id=" + this.cari.user_id + 
                    "&user_login_id=" + this.auth.user.id,'_blank');
        },
        async getQueryData() {
            // const resp = await axios.get(
            //     this.service_laporan+'kutipan/laporan/kaunter/batal_kaunter?tarikh_dari=' +
            //         this.cari.tarikh_dari +
            //         "&tarikh_hingga=" + this.cari.tarikh_hingga +
            //         "&kaunter_id=" + this.cari.kaunter_id +
            //         "&user_id=" + this.cari.user_id + 
            //         "&user_login_id=" + this.auth.user.id
            // );
            // this.resit_batal = resp.data;
            // console.log(resp.data);
            this.isLoading = true
            const resp = await axios.get(
                this.service_laporan+'kutipan/laporan/kaunter/senarai_resit?tarikh_dari=' +
                    this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&kaunter_id=" + this.cari.kaunter_id +
                    "&user_id=" + this.cari.user_id + 
                    "&user_login_id=" + this.auth.user.id + 
                    "&page=" + this.cari.page +
                    "&per_page=" + this.cari.per_page,
            );
            this.table = resp.data.data;
            this.table.meta = resp.data.meta;
            this.isLoading = false
        },
    },
    watch: {
        // table(){
        //     this.isLoading = false
        // }
    },
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.kaunter_id == "undefined") {
            this.cari.kaunter_id = "";
        }
        if (this.cari.user_id == "undefined") {
            this.cari.user_id = "";
        }
        if(typeof this.cari.per_page === 'undefined'){
            this.cari.per_page = 10;
        } else {
            this.cari.per_page = parseInt(this.cari.per_page);
        }
        if(this.cari.page)
            this.getQueryData()
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
